import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/vr-page.vue'
wx.createPage(MiniProgramPage)